import React from 'react';
import '../styles/Gallery.css';

const galleryItems = [
  { icon:  '✦', label: 'Facials' },
  { icon: '👁', label: 'Lash Lifts' },
  { icon: '★', label: 'Brow Work' },
  { icon: '💧', label: 'HydraFacial' },
  { icon: '✿', label: 'Peels' },
  { icon: '♥', label: 'Waxing' },
  { icon: '🎁', label: 'Spa Days' },
  { icon: '☀', label: 'Anti-Aging' },
];

function Gallery() {
    return (
        <section className='gallery' id='gallery'>
            <div className='section-header'>
                <div className='section-tag'>Our work</div>
                <h2 className='section-title'>Gallery</h2>
                <p className='section-sub'>A glipmse of thr transformations we create every day</p>
            </div>

            <div className='gallery-grid'>
                {galleryItems.map((item, index) => (
                    <div className='gallery-item' key={index}>
                        <span className='gallery-icon'>{item.icon}</span>
                        <span className='gallery-label'>{item.label}</span>
                    </div>    
                ))}
            </div>

            <p className='gallery-note'>...</p>
        </section>
    );
}

export default Gallery;